import React, { useEffect, useRef } from "react";
import Footer from "../Footer";
import Header from "../Header";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { blobURL } from "common/StringUtils";

const BussinesInfo = ({ dashboardFooter }) => {
  const { t } = useTranslation();
  const readMore = useRef(true);
  const salaries = `${blobURL}/salaries2.jpg`;

  useEffect(() => {
    readMore.current.scrollIntoView();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="home-page">
      <Helmet>
        <title>{t("Effective Payroll Management - Invozio Business")}</title>
        <meta
          name="description"
          content={t(
            "Invozio offers flexible and cost-effective payroll administration for extra staff, startups and growth companies. Relieve your finance department today."
          )}
        />
      </Helmet>
      <Header />

      <section className="payroll_section_wrap" ref={readMore}>
        <div
          className="banner-image business-info-banner-image p-0 m-0 d-flex align-items-center"
          style={{ backgroundImage: `url(${salaries})` }}
        >
          <div className="container">
            <div className="left-container py-2">
              <div className="hading-text p-0">
                <h1 className="payroll_txt">
                  {t("External help for salaries")}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-5">
        <div className="container">
          <div className="w-full md:w-4/6 px-4 m-auto mb-8">
            <div>
              <h2 className="h4">
                {t("We offer customized business solutions")}
              </h2>
              <p>
                {t("Here at Invozio Business, we offer a complementary,")}
                {t(
                  "cost-effective and flexible solution for payroll administration"
                )}
                {t("of extra staff who work on and off.")}
              </p>
              <h2 className="h4">
                {t("Company with its own payroll and finance department")}
              </h2>
              <p>
                {t(
                  "With us as a partner, we become a complement and relief to your"
                )}
              </p>
              <h2 className="h4">
                {t("Payroll management, startups and growth companies")}
              </h2>
              <p>{t("As an employer, we assume full")}</p>
              <h2 className="h4">
                {t("Outsource your payroll administration")}
              </h2>
              <p>{t("Invozio Bussines manage personnel")}</p>
              <h2 className="h4">
                {t("Avoid payroll administration and payroll processing")}
              </h2>
              <p>{t("We take responsibility for payroll")}</p>
              <h2 className="h4">
                {t("Platform companies within B2B or B2C")}
              </h2>
              <p>
                {t(
                  "Companies that build and offer services via an app or portal to"
                )}
                {t("customers within B2B or B2C and that are looking for a")}
                {t(
                  "collaboration partner who can manage employment and salary"
                )}
                {t("payments. We have many collaborations with market-leading")}
                {t(
                  "platform companies today and can offer flexible integrations to"
                )}
                {t(
                  "our systems and services. We also have our own IT department"
                )}
                {t("that helps with the work.")}
              </p>
              <h2 className="h4">
                {t("Reduced administration for payroll processing")}
              </h2>
              <p>
                {t("A complementary, cost-effective and flexible solution for")}
                {t(
                  "payroll administration of extra staff who work on and off."
                )}
              </p>
              <h2 className="h4">{t("Combined invoice")}</h2>
              <p>
                {t(
                  "Regardless of how many employees were affected during a month,"
                )}
                {t("we collect everything on one invoice.")}
              </p>
              <h2 className="h4">{t("Safe partner")}</h2>
              <p>
                {t(
                  "We ensure that all your extra staff are properly insured and"
                )}
              </p>
              <a href="mailto:info@invozio.com">info@invozio.com</a>
            </div>
          </div>
        </div>
      </section>
      <div className="home-page"></div>

      <Footer dashboardFooter={dashboardFooter} />
    </div>
  );
};

export default BussinesInfo;
